import React, { Component } from 'react'
import { connect } from 'react-redux'

import { hasSubscriptionPermission } from '../../../utils/auth'
import { ElementIcons } from '../../../shared/elements/icons'

import './carrow.scss'

// Elements
import Icon from '../../../shared/elements/icon'

class CarRow extends Component {

  constructor (props) {
    super(props)
    this.state = {

    }
  }

  render () {
    let carRowStyle = {
      height: '48px'
    }
    if (this.props.maxConflicts !== undefined && this.props.maxConflicts > 0) {
      let height = (this.props.maxConflicts + 1) * 48
      height += this.props.maxConflicts
      carRowStyle.height = height + 'px'
    }
    let dayStyle = {}
    if (this.props.days !== undefined && this.props.days.length > 0) {
      dayStyle = {
        // Somehow Edge is broken when using 100%... broken as always.
        width: 'calc(99.97% / ' + this.props.days.length + ')'
      }
    }
    const renderDays = (item, dayIndex) => {
      const dayOnClick = (clickedDate) => {
        if (hasSubscriptionPermission(this.props.auth, 10, 2)) {
          this.props.setCreateOrderValues(true, this.props.car.Id, clickedDate)
        }
      }

      return (
        <div key={this.props.Id + '_' + dayIndex} className='dailydiv gu-nonselectable' style={dayStyle} onClick={dayOnClick.bind(this, item.Date)} data-date={item.Date} />
      )
    }
    const renderTimeIndexes = (item) => {
      let top = item.Index * 48
      top += item.Index
      let indexStyle = {
        top: top + 'px'
      }
      // let sideText = 'left'
      // let markingColorText = 'gray'
      let imageString = ''
      switch (item.SideType) {
        case 0:
          // sideText = 'left'
          imageString = item.Type === 0 ? ElementIcons.Arrow_Left_Gray : ElementIcons.Arrow_Left_Lightgray
          break
        case 1:
          // sideText = 'right'
          imageString = item.Type === 0 ? ElementIcons.Arrow_Right_Gray : ElementIcons.Arrow_Right_Lightgray
          break
      }
      // switch (item.Type) {
      //   case 0:
      //     markingColorText = 'gray'
      //     break
      //   case 1:
      //     markingColorText = 'lightgray'
      //     break
      // }
      // let imageString = '/images/svgs/ordrer/arrow-' + sideText + '-' + markingColorText + '.svg'
      return (
        <div key={Math.random()} className='timearrow'>
          <Icon icon={imageString} style={indexStyle} className='arrow' />
        </div>
      )
    }

    let departmentName = this.props.car.DepartmentName
    let departmentNameText = ''
    if (departmentName) {
      departmentNameText = this.props.car.CarNumber ? ', ' + departmentName : departmentName
    }
    return (
      <div className='car-row' style={carRowStyle}>
        <div className='margin left'>
          <div className='details'>
            <div className='number'>
              <span className='text-ellipsis'>{this.props.car.CarNumber + departmentNameText}</span>
            </div>
            <div className='identification'>
              <span>{this.props.car.Identity}</span>
            </div>
          </div>
          {this.props.car.TimeBeforeIndexes.map(renderTimeIndexes)}
        </div>
        <div className='car-row-content' data-id={this.props.car.Id}>
          {this.props.days.map(renderDays)}
          {this.props.children}
        </div>
        <div className='margin right'>
          {this.props.car.TimeAfterIndexes.map(renderTimeIndexes)}
        </div>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {

})(CarRow)



// WEBPACK FOOTER //
// ./src/app/pages/CarRentalOverview/CarRow/index.js